import { ReactElement } from 'react';
import {
  Alert,
  AlertProps as AlertPropsChakra,
  AlertIcon,
  Text,
} from '@chakra-ui/react';

export interface ErrorProps extends AlertPropsChakra {
  innerHTML?: string;
}

export const Error = ({ innerHTML, ...props }: ErrorProps): ReactElement => (
  <Alert
    status='error'
    mt='4'
    p='4'
    w='100%'
    fontSize='14px'
    bgColor='errors.100'
    borderColor='errors.100'
    borderRadius='4px'
    data-testid='error'
    {...props}
  >
    <AlertIcon color='errors.200' />

    {innerHTML && (
      <Text
        color='text.100'
        fontStyle='italic'
        data-testid='error-text'
        dangerouslySetInnerHTML={{ __html: innerHTML }}
      />
    )}
  </Alert>
);
